import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { GreenplumTableDataset } from 'app/model/dataset/greenplum.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GreenplumTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class GreenplumTableDatasetAdapter extends TabularTypeDatasetAdapter<GreenplumTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: GreenplumTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(GreenplumTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: GreenplumTableDataset): Promise<GreenplumTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, GreenplumTableDataset.MODEL);
    }
}
